import { IAppState } from '../App/interfaces/IAppState'

export function notificationUpdatesSelector(appState: IAppState) {
  return appState.notificationUpdates
}
